import React, { PureComponent } from 'react';
import Switch from 'rc-switch';
import { Trans, t } from '@lingui/macro';
import Chart from '../utils/chartjs';


import chartOptionsGen from '../utils/chartOptionsGen';
import { systemChartHeight } from '../utils';


class SystemWdayDeal extends PureComponent {
    constructor(props) {
        super(props);
        this.graphRefs = React.createRef();
        this.height = systemChartHeight(props.isMobile);
        this.state = {
            showAvg: false,
        };
    }

    componentDidMount() {
        this.drawChart();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.yyyymm === 'all') this.handleSwitchChange(false);
    }

    drawChart = () => {
        const { data, numOfWeekDayInThisDateRange } = this.props;
        const { showAvg } = this.state;
        let datasets = Object.values(data);
        if (showAvg) { datasets = datasets.map((d, index) => Math.round(d / numOfWeekDayInThisDateRange[index])); }

        if (this.chart) {
            this.chart.data.datasets = this._genDatasets(datasets);
            this.chart.update();
        } else {
            const ctx = this.graphRefs.current.getContext('2d');
            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
                    datasets: this._genDatasets(datasets),
                },
                options: chartOptionsGen.options('black'),
            });
        }
    }

    handleSwitchChange = (value) => {
        this.setState({ showAvg: value }, () => this.drawChart());
    }

    _genDatasets = (datasets) => [
        chartOptionsGen.genData({
            data: datasets,
            bkgColor: 'rgba(54, 162, 235, 0.5)',
            borderColor: 'rgba(54, 162, 235, 1)',
            hoverBackgroundColor: 'rgba(54, 162, 235, 0.8)',
            hoverBorderColor: 'rgba(54, 162, 235, 1)',
            label: t({ id: 'common.transaction' }),
        }),
    ]

    render() {
        const { width } = this.props;
        return (
            <div>
                <h3 className="system-head">
                    <Trans id="system.weekdealTitle" />
                </h3>
                <div className="switch-wrapper">
                    <span>
                        <Trans id="common.total" />
                    </span>
                    <Switch onChange={this.handleSwitchChange} />
                    <span>
                        <Trans id="common.average" />
                    </span>
                </div>
                <canvas
                    ref={this.graphRefs}
                    width={width}
                    height={this.height}
                />
            </div>
        );
    }
}
export default SystemWdayDeal;
